import {
  Boxes,
  Package,
  Heart,
  Gift,
  Box,
  Palette,
  Sparkles,
  Home,
  Lightbulb,
  Puzzle,
  Wrench,
  Rocket,
} from "lucide-react";

// The icons an administrator can pick for a category. Kept deliberately short:
// a long list makes the dropdown useless and the homepage inconsistent.
export const CATEGORY_ICONS = {
  Boxes,
  Package,
  Heart,
  Gift,
  Box,
  Palette,
  Sparkles,
  Home,
  Lightbulb,
  Puzzle,
  Wrench,
  Rocket,
};

export const CATEGORY_ICON_NAMES = Object.keys(CATEGORY_ICONS);

// Used when a featured category has neither an image nor a chosen icon.
export const DEFAULT_CATEGORY_ICON = Boxes;

export const iconFor = (name) => CATEGORY_ICONS[name] || DEFAULT_CATEGORY_ICON;
